import React, { useState, useEffect } from 'react';

export default function DealSection() {
  const [timeLeft, setTimeLeft] = useState({ hours: 12, minutes: 45, seconds: 30 });

  useEffect(() => {
    let totalSeconds = 12 * 3600 + 45 * 60 + 30;
    const interval = setInterval(() => {
      totalSeconds--;
      if (totalSeconds < 0) {
        clearInterval(interval);
        return;
      }
      setTimeLeft({
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-4 lg:px-6 mt-12">
      <div className="rounded-[28px] bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 p-8 lg:p-10 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: 'radial-gradient(white 1px, transparent 1px)', backgroundSize: '20px 20px' }}></div>
        <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-6">
          <div>
            <p className="text-xs font-bold tracking-widest uppercase text-fuchsia-300">DEAL OF THE DAY</p>
            <h3 className="font-display text-[32px] mt-1">Crazy Steals • Up to 80% Off</h3>
            <p className="text-white/70 text-sm mt-1">
              Ends in <span className="font-mono font-bold text-white">
                {String(timeLeft.hours).padStart(2, '0')}:{String(timeLeft.minutes).padStart(2, '0')}:{String(timeLeft.seconds).padStart(2, '0')}
              </span>
            </p>
          </div>
          <div className="flex gap-3 overflow-x-auto no-scrollbar">
            <div className="min-w-[160px] rounded-2xl bg-white/10 backdrop-blur p-3 border border-white/10">
              <img src="https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?q=80&w=400&auto=format" className="h-28 w-full object-cover rounded-xl" alt="product" />
              <p className="text-xs mt-2 font-semibold">Oversized Tee</p>
              <p className="text-[11px] text-white/70">₹499 <span className="line-through opacity-60">₹1499</span></p>
            </div>
            <div className="min-w-[160px] rounded-2xl bg-white/10 backdrop-blur p-3 border border-white/10">
              <img src="https://images.unsplash.com/photo-1549298916-b41d501d3772?q=80&w=400&auto=format" className="h-28 w-full object-cover rounded-xl" alt="product" />
              <p className="text-xs mt-2 font-semibold">Chunky Sneakers</p>
              <p className="text-[11px] text-white/70">₹1999 <span className="line-through opacity-60">₹4999</span></p>
            </div>
            <div className="min-w-[160px] rounded-2xl bg-white/10 backdrop-blur p-3 border border-white/10">
              <img src="https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?q=80&w=400&auto=format" className="h-28 w-full object-cover rounded-xl" alt="product" />
              <p className="text-xs mt-2 font-semibold">Summer Dress</p>
              <p className="text-[11px] text-white/70">₹899 <span className="line-through opacity-60">₹2999</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}